<template>
  <CollapseFilters ref="collapse">
    <Form ref="form" @submit.prevent>
      <div class="row g-4">
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("status") }}</label>
          <StatusDropdown v-model="filters.status" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("tipoValor") }}</label>
          <ValueTypeSelect v-model="filters.valueType" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("datas") }}</label>
          <MonthSelect v-model="filters.days" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("usuario") }}</label>
          <UsersDropdown v-model="filters.users" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("cliente") }}</label>
          <ClientesDropdown v-model="filters.clientes" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("servico") }}</label>
          <ServicosDropdown v-model="filters.servicos" />
        </div>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <LoadingButton class="btn-primary" :loading="loading" @click="onClick">
          <i class="bi bi-filter" /> {{ $t("filtrar") }}
        </LoadingButton>
      </div>
    </Form>
  </CollapseFilters>
</template>

<script>
import CollapseFilters from '@/modules/shared/components/CollapseFilters.vue';
import Form from '@/modules/core/components/FormInput.vue';
import StatusDropdown from '@/modules/shared/components/StatusDropdown.vue';
import ValueTypeSelect from '@/modules/shared/components/ValueTypeSelect.vue';
import MonthSelect from '@/modules/shared/components/MonthSelect.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import UsersDropdown from '@/modules/shared/components/UsersDropdown.vue';
import ClientesDropdown from '@/modules/shared/components/ClientesDropdown.vue';
import ServicosDropdown from '@/modules/shared/components/ServicosDropdown.vue';

export default {
  components: {
    CollapseFilters,
    Form,
    StatusDropdown,
    ValueTypeSelect,
    MonthSelect,
    UsersDropdown,
    LoadingButton,
    ClientesDropdown,
    ServicosDropdown,
  },
  props: {
    loading: { type: Boolean, required: true },
  },
  emits: ['filter'],
  data: () => ({
    filters: {
      days: '366',
      status: [3],
      valueType: '0',
      users: [],
      clientes: [],
      servicos: [],
    },
  }),
  mounted() { this.$emit('filter', this.filters); },
  methods: {
    onClick() {
      if (this.$refs.form.validate()) {
        this.$emit('filter', this.filters);
        this.$refs.collapse.toggle();
      }
    },
  },
};
</script>
